teardown =
	teardown: ->

module.exports = (select, sourceKeypath) ->
	$select = $ select
	$select.on 'selectric-change', => @updateModel()

	return teardown unless $select.is '.ractive'

	$select.selectric
		arrowButtonMarkup: '<b class="btn">&#9662;</b>'
		labelBuilder: (currItem) ->
			imageSrc = currItem.element.data 'image'
			return currItem.text unless imageSrc

			if currItem.value.length
				'<img class="ico" src="' + imageSrc + '"></span>' + currItem.text
			else
				currItem.text
		optionsItemBuilder: (itemData, element) ->
			imageSrc = element.data 'image'
			return itemData.text unless imageSrc

			if element.val().length
				'<img class="ico" src="' + imageSrc + '"></span>' + itemData.text
			else
				itemData.text

	return teardown unless sourceKeypath

	@observe sourceKeypath, (newValue) ->
		return if _.isUndefined newValue

		isDisabled = $select.prop 'disabled'
		$select.prop 'disabled', true if newValue.length is 1 and not isDisabled
		$select.prop 'disabled', false if newValue.length > 1 and isDisabled

		setTimeout ->
			$select.selectric 'refresh'
		, 0

	return teardown


/** WEBPACK FOOTER **
 ** ./assets/coffee/decorators/selectric.coffee
 **/